// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-title[data-v-01eb2749]{margin-bottom:15px;font-weight:500;font-size:32px;line-height:40px;color:#000}.form-text[data-v-01eb2749]{margin-bottom:30px;font-weight:400;font-size:16px;line-height:24px;color:rgba(7,6,0,.7)}", ""]);
// Exports
module.exports = exports;
